import { navMenu } from "@lib/data"
import { Fragment } from "react"
import { useRouteShellContext } from "@components/routeShellContext"
import "./styles.css"

export function NavMenu() {
  const { locale, currentPage } = useRouteShellContext()

  return (
    <ul>
      {navMenu(locale).map((item) => (
        <Fragment key={item.label}>
          {item.page === "index" ? (
            <li
              className="nav-separator"
              aria-hidden="true"
            />
          ) : null}
          <li className={currentPage === item.page ? "active" : ""}>
            <a
              aria-label={item.label}
              href={item.href}
              target={item.external ? "_blank" : undefined}
              rel={item.external ? "noreferrer" : undefined}
            >
              <i className={item.icon} />
              <span>{item.label}</span>
            </a>
          </li>
        </Fragment>
      ))}
    </ul>
  )
}

export default NavMenu
